export const normalizeSearchValue = (value) =>
  String(value ?? '')
    .trim()
    .toLowerCase()

export const parseFacilityOtherDetails = (otherDetails) => {
  if (!otherDetails || otherDetails === 'undefined') return {}
  if (typeof otherDetails === 'object') return otherDetails

  try {
    const parsed = JSON.parse(otherDetails) || {}
    return typeof parsed === 'string' ? parseFacilityOtherDetails(parsed) : parsed
  } catch (e) {
    return {}
  }
}

export const getFacilityParentCompany = (source = {}) => {
  const otherDetails = parseFacilityOtherDetails(source?.OtherDetails ?? source?.otherDetails ?? source)
  return (
    source?.facilityParentCompany ||
    source?.parentCompany ||
    source?.ParentCompany ||
    source?.parentCompanyName ||
    source?.ParentCompanyName ||
    source?.parent_company ||
    otherDetails?.ParentCompany ||
    otherDetails?.parentCompany ||
    otherDetails?.ParentCompanyName ||
    otherDetails?.parentCompanyName ||
    otherDetails?.parent_company ||
    otherDetails?.SisterCompany ||
    ''
  )
}

export const formatFacilityOption = (facility = {}) => ({
  ...facility,
  value: facility?.value ?? facility?.ID ?? facility?.FacilityID ?? '',
  label: facility?.label ?? facility?.Name ?? facility?.FacilityName ?? '',
  parentCompany: getFacilityParentCompany(facility),
})

export const getPatientFacilityParentCompany = (patient, facilityOptions = []) => {
  const patientParentCompany = getFacilityParentCompany(patient)
  if (patientParentCompany) return patientParentCompany

  const facilityID = patient?.current?.Facility?.value || patient?.data?.FacilityID || patient?.FacilityID
  const facilityName = patient?.FacilityName || patient?.current?.Facility?.label || patient?.data?.Facility

  const matchedFacility = facilityOptions.find((facility) => {
    const optionID = facility?.value || facility?.ID || facility?.FacilityID
    const optionName = facility?.label || facility?.Name || facility?.FacilityName
    const normalizedOptionName = normalizeSearchValue(optionName)
    const normalizedFacilityName = normalizeSearchValue(facilityName)
    const hasMatchingID = optionID !== undefined && optionID !== null && facilityID !== undefined && facilityID !== null && String(optionID) === String(facilityID)
    const hasMatchingName = normalizedOptionName && normalizedFacilityName && normalizedOptionName === normalizedFacilityName
    return hasMatchingID || hasMatchingName
  })

  return getFacilityParentCompany(matchedFacility)
}

export const searchableMatches = (fields = [], searchValue = '') => {
  const normalizedSearchValue = normalizeSearchValue(searchValue)
  if (!normalizedSearchValue) return true

  return fields.some((field) => normalizeSearchValue(field).includes(normalizedSearchValue))
}
